export enum ProductCategories {
    AUDIO = 'audio',
    ART = 'art',
    EBOOK = 'ebook',
    BOOK = 'book'
}